import {
  Component,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { distinctUntilChanged, filter, switchMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { getLoadingState, getSelectedHolding } from 'src/app/modules/acbcr/common/state/reducers/holdings.reducers';
import { ReproductionsTableService } from 'src/app/modules/acbcr/common/services/reproductions-table.service';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-anexa3-tab',
  templateUrl: './anexa3-tab.component.html',
  styleUrls: ['./anexa3-tab.component.scss'],
})
export class Anexa3TabComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();

  isAdmin = false;
  isOperator = false;
  anexe3 = [];
  selectedHolding;
  modalData = null;
  openDelete = false;
  idDelete;

  constructor(
    private helperDataService: HelperDataService,
    private reproductionsTableService: ReproductionsTableService,
    private store: Store<ApplicationState>,
    public modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    this.isAdmin = UIHelper.isAdmin();
    this.isOperator = UIHelper.isOperator();

    this.store.pipe(
      select(getLoadingState),
      filter(isLoading => !isLoading),
      switchMap(() => this.store.pipe(select(getSelectedHolding))),
      distinctUntilChanged((prev, curr) => prev.id === curr.id),
      takeUntil(this.destroy$),
    ).subscribe((response: any) => {
        this.selectedHolding = response;
        if (this.selectedHolding !== undefined && this.selectedHolding.id > 0) {
          this.getTableData();
        }
    });
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

  downloadAnexa3(anexa) {
    this.reproductionsTableService
      .getAnexa3Pdf(this.selectedHolding.id, anexa.id)
      .subscribe((response: any) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        this.helperDataService.simulateDownload(blob, `Anexa3_${anexa.id}.pdf`);
      });
  }

  openAnexa3(anexa3Id) {
    this.modalData = {
      'anexa_id': anexa3Id,
      'modal_type': 'reproductii',
    };
  }

  getModalResult(event) {
    this.getTableData();
  }

  openDeleteModal(id) {
    this.openDelete = true;
    this.idDelete = id;
  }

  closeDeleteModal(event) {
    this.openDelete = false;

    if (event != true) {
      return;
    }

    let buton = document.getElementsByClassName('sterge-id-' + this.idDelete)[0];
    buton?.setAttribute('disabled', 'true');

    this.reproductionsTableService
      .anexa3Delete(this.idDelete)
      .subscribe({
        next: (response) => {
          this.getTableData();
        },
      });
  }

  private getTableData() {
    if (this.selectedHolding) {
      this.reproductionsTableService
        .getAnexa3Data({ company_id: this.selectedHolding.id })
        .subscribe((response) => (this.anexe3 = response));
    }
  }
}
